import { registerMockAPI } from '~/mocks/mockApis';

import { useDownloadMutation } from '~/hooks/common';
import { axiosInstance, downloadBlobDataFile } from '~/services';

import { API_ENDPOINT } from '~/constants';

import type { TypeGetReceivingRequestsRequestedDownloadParams } from '~/types/receive.types';

type TypeGetRequestsRequestedDownloadMutationParams = TypeGetReceivingRequestsRequestedDownloadParams & {
  ownerCode: string;
};

const fetchRequestsRequestedDownload = async ({
  ownerCode,
  ...params
}: TypeGetRequestsRequestedDownloadMutationParams): Promise<void> => {
  const response = await axiosInstance.get(
    `${API_ENDPOINT.RECEIVE.GET_REQUESTS_REQUESTED_DOWNLOAD}/${ownerCode}/requests/requested/download`,
    {
      params,
      responseType: 'blob',
    }
  );

  downloadBlobDataFile(response);
};

/**
 * [입고관리 > 입고요청관리] 입고요청 엑셀 다운로드 Mutation Hook
 */
export const useGetRequestsRequestedDownloadMutation = () => {
  return useDownloadMutation(fetchRequestsRequestedDownload);
};

registerMockAPI<null>({
  method: 'get',
  endpoint: '/api-inbound/v1/3pl/receiving/:ownerCode/requests/requested/download',
  label: '입고/입고요청/목록다운로드',
  scenarios: [
    { name: '정상 응답', response: null },
    {
      name: '서버 오류',
      response: { error: { message: '입고요청 목록 다운로드 중 오류가 발생했습니다.' } },
      status: 500,
    },
  ],
});
